export const ROOM_RECEIVE_MESSAGE = 'ReceiveMessage'
